import { motion } from "framer-motion";
import { Heart, Gem, Wallet } from "lucide-react";
import { fadeInUp, staggerContainer } from "@/components/motionVariants";

const cards = [
  {
    id: "love",
    title: "ความรัก",
    icon: Heart,
    image:
      "https://images.unsplash.com/photo-1658851866325-49fb8b7fbcb2?crop=entropy&cs=srgb&fm=jpg&q=85",
    questions: ["เขานอกใจหรือไม่?", "เขาคิดอะไรอยู่?", "เราจะได้แต่งงานกันไหม?"],
  },
  {
    id: "soulmate",
    title: "คู่แท้",
    icon: Gem,
    image:
      "https://images.unsplash.com/photo-1540488187186-9c9f3d4e2459?crop=entropy&cs=srgb&fm=jpg&q=85",
    questions: ["คนนี้ใช่คู่ชีวิตหรือไม่?", "เมื่อไหร่จะเจอคนที่ใช่?"],
  },
  {
    id: "money",
    title: "การเงิน",
    icon: Wallet,
    image:
      "https://images.unsplash.com/photo-1734050622502-cd9818c92c95?crop=entropy&cs=srgb&fm=jpg&q=85",
    questions: ["ควรเปลี่ยนงานไหม?", "ธุรกิจนี้จะสำเร็จหรือไม่?"],
  },
];

export const EmotionalTriggers = ({ lineUrl }) => {
  return (
    <motion.section
      id="triggers"
      className="py-16 md:py-24"
      data-testid="emotional-triggers-section"
      {...fadeInUp}
    >
      <div className="mx-auto max-w-md px-6 md:max-w-4xl md:px-12 lg:max-w-6xl">
        <motion.h2
          {...fadeInUp}
          className="font-serif text-3xl text-taupe md:text-4xl"
          data-testid="emotional-triggers-title"
        >
          คุณกำลังกังวลเรื่องนี้อยู่หรือไม่?
        </motion.h2>
        <motion.p
          {...fadeInUp}
          className="mt-4 text-base text-taupeLight"
          data-testid="emotional-triggers-subtitle"
        >
          ความรักและชีวิตไม่จำเป็นต้องแบกไว้คนเดียว เราอยู่ตรงนี้เพื่อให้คำตอบที่ชัดเจนและอ่อนโยน
        </motion.p>
        <motion.div
          variants={staggerContainer}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
          className="mt-10 grid gap-6 md:grid-cols-3"
          data-testid="emotional-triggers-grid"
        >
          {cards.map((card) => {
            const Icon = card.icon;
            return (
              <motion.div
                key={card.id}
                variants={fadeInUp}
                className="group flex h-full flex-col overflow-hidden rounded-2xl border border-rose/30 bg-white shadow-soft transition-transform duration-300 hover:-translate-y-1"
                data-testid={`trigger-card-${card.id}`}
              >
                <img
                  src={card.image}
                  alt={`คำถามเรื่อง${card.title}`}
                  className="h-40 w-full object-cover"
                  loading="lazy"
                  data-testid={`trigger-card-image-${card.id}`}
                />
                <div className="flex flex-1 flex-col p-6">
                  <div className="flex items-center gap-3">
                    <div
                      className="flex h-10 w-10 items-center justify-center rounded-full bg-rose/30"
                      data-testid={`trigger-card-icon-${card.id}`}
                    >
                      <Icon className="h-5 w-5 text-taupe" />
                    </div>
                    <h3 className="text-xl font-semibold text-taupe" data-testid={`trigger-card-title-${card.id}`}>
                      {card.title}
                    </h3>
                  </div>
                  <ul className="mt-4 space-y-2 text-sm text-taupeLight" data-testid={`trigger-card-questions-${card.id}`}>
                    {card.questions.map((question, index) => (
                      <li key={question} data-testid={`trigger-card-question-${card.id}-${index}`}>
                        • {question}
                      </li>
                    ))}
                  </ul>
                  <a
                    href={lineUrl}
                    target="_blank"
                    rel="noreferrer"
                    className="mt-6 inline-flex items-center justify-center rounded-full border border-line/40 px-4 py-2 text-sm font-semibold text-line transition-colors duration-300 hover:bg-line hover:text-white"
                    data-testid={`trigger-card-cta-${card.id}`}
                    aria-label={`ถามผ่าน LINE เกี่ยวกับ${card.title}`}
                  >
                    ถามผ่าน LINE
                  </a>
                </div>
              </motion.div>
            );
          })}
        </motion.div>
      </div>
    </motion.section>
  );
};